import React from 'react';
interface CTAButtonProps {
  text: string;
  subtitle: string;
  onClick?: () => void;
  scrollTo?: string;
  redirectToCheckout?: boolean;
  trackInitiateCheckout?: boolean;
}
export function CTAButton({
  text,
  subtitle,
  onClick,
  scrollTo = 'producto',
  redirectToCheckout = false,
  trackInitiateCheckout = false
}: CTAButtonProps) {
  const handleClick = () => {
    if ((trackInitiateCheckout || redirectToCheckout) && typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'LPM™ System Guide',
        content_ids: ['50963070517533'],
        content_type: 'product',
        value: 49999,
        currency: 'COP'
      });
    }
    if (onClick) {
      onClick();
    } else if (redirectToCheckout) {
      window.open('https://www.tiendasamazonica.com/cart/50963070517533:1', '_blank');
    } else {
      const section = document.getElementById(scrollTo);
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <div className="flex flex-col items-center w-full" data-id="element-55">
      <button onClick={handleClick} className="w-full md:w-auto font-bold py-4 px-8 rounded-md text-lg transition-colors duration-150 cursor-pointer" style={{
      backgroundColor: '#f59e0b',
      color: '#0f172a'
    }} onMouseEnter={e => {
      ;
      (e.target as HTMLElement).style.backgroundColor = '#d97706';
    }} onMouseLeave={e => {
      ;
      (e.target as HTMLElement).style.backgroundColor = '#f59e0b';
    }} type="button" data-id="element-56">
        {text} →
      </button>
      <p className="text-sm font-mono mt-2 text-center" style={{
      color: '#94a3b8'
    }} data-id="element-57">
        {subtitle}
      </p>
    </div>;
}